import React, { useEffect } from 'react';
import '../../../../stylesheets/stylesLayout/yourProperties.scss';
import LoadedOptionsTypeaheadV2 from '../../../../muiComponents/LoadedOptionsTypeaheadV2';
import TextInput from '../../../../muiComponents/TextInput/TextInputV2';
import Grid from '../../../../muiComponents/Grid';
import GridChild from '../../../../muiComponents/GridChild';
import {
    doubleColumnGrid,
    gridColumnsSpacing,
    gridRowsSpacing,
} from '../../../../utils/property/propertyUtils';
import {
    useProperty,
    usePropertyComplementaryData,
    usePropertyFetching,
    usePropertyValidation,
} from '../../../contextsProperty/ContextProperties';
import { PROGRESS_MAIN_INFORMATION_TAB } from '../../../../types/properties/propertyTypes';
import LoadingTab from '../LoadingTab';
import Title from '../Title';
import Card from '../../../../muiComponents/Card';

export default function Property() {
    const {
        primary,
        idHotelType,
        idHotelCategory,
        idHotelChain,
        idCurrency,
        checkInHour,
        checkOutHour,
        roomCount,
        handleInputChange,
    } = useProperty();
    const { handleIsValidated, errors, isValidated, handleValidate } =
        usePropertyValidation();
    const {
        hotelTypesList,
        hotelCategoriesList,
        hotelChainsList,
        currenciesList,
    } = usePropertyComplementaryData();
    const { isFetching } = usePropertyFetching();

    useEffect(() => {
        return () => handleIsValidated(false);
    }, []);

    const handleBlur = () => {
        if (isValidated) {
            handleValidate(PROGRESS_MAIN_INFORMATION_TAB.PROPERTY);
        }
    };

    const isInputDisabled = !primary;

    const autocompleteInputProps = {
        sx: {
            '& .MuiOutlinedInput-root': {
                height: '50px',
                fontSize: '1.2rem',
            },
            '& .MuiFilledInput-root': {
                height: '50px',
                fontSize: '1.2rem',
            },
            '& .MuiInputLabel-shrink': {
                top: '0 !important',
            },
            '& .MuiInputLabel-outlined': {
                fontSize: '1.2rem',
                // top: '-5px',
            },
            '& .MuiInputLabel-filled': {
                fontSize: '1.2rem',
                top: '-5px',
            },
        },
        variant: isInputDisabled ? 'filled' : 'outlined',
    };

    const variant = isInputDisabled ? 'filled' : 'outlined';
    if (isFetching) {
        return <LoadingTab />;
    }
    return (
        <div className='your-property__container'>
            <Title
                as='h1'
                text={'hotel_features'}
                className='text-align-center'
            />
            <Card className='your-properties__form'>
                <Grid
                    columnSpacing={gridColumnsSpacing}
                    rowSpacing={gridRowsSpacing}
                >
                    <GridChild gridProps={doubleColumnGrid}>
                        <LoadedOptionsTypeaheadV2
                            labelText='property_segment'
                            options={hotelTypesList}
                            handleChange={(e, newValue) => {
                                handleInputChange(
                                    'idHotelType',
                                    newValue ? parseInt(newValue.Id) : 0
                                );
                            }}
                            idValue={idHotelType || 0}
                            onBlur={handleBlur}
                            errorMessage={errors.idHotelType}
                            required
                            disabled={isInputDisabled}
                            inputProps={autocompleteInputProps}
                            name='idHotelType'
                            idValueKey='id'
                            optionsLabelKey='name'
                        />
                    </GridChild>
                    <GridChild gridProps={doubleColumnGrid}>
                        <LoadedOptionsTypeaheadV2
                            labelText='category'
                            options={hotelCategoriesList}
                            handleChange={(e, newValue) => {
                                handleInputChange(
                                    'idHotelCategory',
                                    newValue ? parseInt(newValue.Id) : 0
                                );
                            }}
                            idValue={idHotelCategory || 0}
                            onBlur={handleBlur}
                            errorMessage={errors.idHotelCategory}
                            required
                            disabled={isInputDisabled}
                            inputProps={autocompleteInputProps}
                            name='idHotelCategory'
                            idValueKey='id'
                            optionsLabelKey='name'
                        />
                    </GridChild>
                    <GridChild gridProps={doubleColumnGrid}>
                        <LoadedOptionsTypeaheadV2
                            labelText='chain'
                            options={hotelChainsList}
                            handleChange={(e, newValue) => {
                                handleInputChange(
                                    'idHotelChain',
                                    newValue ? parseInt(newValue.Id) : 0
                                );
                            }}
                            idValue={idHotelChain}
                            disabled={isInputDisabled}
                            inputProps={autocompleteInputProps}
                            name='idHotelChain'
                            idValueKey='id'
                            optionsLabelKey='name'
                        />
                    </GridChild>
                    <GridChild gridProps={doubleColumnGrid}>
                        <TextInput
                            labelText='amount_rooms'
                            handleChange={e =>
                                handleInputChange(
                                    'roomCount',
                                    parseInt(e.target.value)
                                )
                            }
                            value={roomCount || 0}
                            errorMessage={errors.roomCount}
                            onBlur={handleBlur}
                            name='roomCount'
                            type='number'
                            required
                            disabled={isInputDisabled}
                            variant={variant}
                            error={!!errors.roomCount}
                        />
                    </GridChild>
                    <GridChild gridProps={doubleColumnGrid}>
                        <LoadedOptionsTypeaheadV2
                            labelText='Currency'
                            options={currenciesList}
                            handleChange={(e, newValue) => {
                                handleInputChange(
                                    'idCurrency',
                                    newValue ? parseInt(newValue.Id) : 0
                                );
                            }}
                            idValue={idCurrency || 0}
                            onBlur={handleBlur}
                            errorMessage={errors.idCurrency}
                            disabled={isInputDisabled}
                            inputProps={autocompleteInputProps}
                            name='idCurrency'
                            required
                            idValueKey='id'
                            optionsLabelKey='name'
                        />
                    </GridChild>
                    <GridChild gridProps={doubleColumnGrid}>
                        <TextInput
                            labelText='check_in_hour'
                            handleChange={e =>
                                handleInputChange('checkInHour', e.target.value)
                            }
                            value={checkInHour}
                            errorMessage={errors.checkInHour}
                            name='checkInHour'
                            type='time'
                            disabled={isInputDisabled}
                            variant={variant}
                        />
                    </GridChild>
                    <GridChild gridProps={doubleColumnGrid}>
                        <TextInput
                            labelText='check_out_hour'
                            handleChange={e =>
                                handleInputChange(
                                    'checkOutHour',
                                    e.target.value
                                )
                            }
                            value={checkOutHour}
                            errorMessage={errors.checkOutHour}
                            name='checkOutHour'
                            type='time'
                            disabled={isInputDisabled}
                            variant={variant}
                        />
                    </GridChild>
                </Grid>
            </Card>
        </div>
    );
}
